import { api, authHeaders } from '../api/api';

export interface PromptTemplate {
  id: string;
  prompt_name: string;
  version: number;
  content: string;
  is_active: boolean;
  is_deactivated: boolean;
  created_at: string;
  created_by?: string;
  updated_at: string;
  updated_by?: string;
  description?: string;
}

export interface CreatePromptPayload {
  prompt_name: string;
  content: string;
  description?: string;
  created_by?: string;
}

export const promptService = {
  getAllPrompts: async (includeDeactivated = false): Promise<PromptTemplate[]> => {
    const headers = await authHeaders();
    const response = await api.get<PromptTemplate[]>(
      `/api/prompts/?include_deactivated=${includeDeactivated}`,
      { headers }
    );
    return response.data;
  },

  getPromptVersions: async (promptName: string): Promise<PromptTemplate[]> => {
    const headers = await authHeaders();
    const response = await api.get<PromptTemplate[]>(
      `/api/prompts/${promptName}/versions`,
      { headers }
    );
    return response.data;
  },

  createPrompt: async (payload: CreatePromptPayload): Promise<PromptTemplate> => {
    const headers = await authHeaders();
    const response = await api.post<PromptTemplate>('/api/prompts/', payload, { headers });
    return response.data;
  },

  activatePrompt: async (promptId: string, promptName: string): Promise<{ message: string }> => {
    const headers = await authHeaders();
    const response = await api.put<{ message: string }>(
      `/api/prompts/${promptId}/activate?prompt_name=${promptName}`,
      undefined,
      { headers }
    );
    return response.data;
  },

  deactivatePrompt: async (promptId: string, promptName: string): Promise<{ message: string }> => {
    const headers = await authHeaders();
    const response = await api.put<{ message: string }>(
      `/api/prompts/${promptId}/deactivate?prompt_name=${promptName}`,
      undefined,
      { headers }
    );
    return response.data;
  },

  updatePrompt: async (promptId: string, payload: CreatePromptPayload): Promise<PromptTemplate> => {
    const headers = await authHeaders();
    const response = await api.put<PromptTemplate>(
      `/api/prompts/${promptId}?prompt_name=${payload.prompt_name}`,
      payload,
      { headers }
    );
    return response.data;
  },

  deletePrompt: async (promptId: string, promptName: string): Promise<{ message: string }> => {
    const headers = await authHeaders();
    const response = await api.delete<{ message: string }>(
      `/api/prompts/${promptId}?prompt_name=${promptName}`,
      { headers }
    );
    return response.data;
  },
};


